export const WooBasketBuilder = () => {
	const button = document.querySelector(".js-basket-builder-submit");
	const guest_email = document.querySelector(".js-basket-builder-guest-email");

	let email = "";

	// Check for button
	if (button) {
		button.addEventListener("click", () => {
			email = guest_email.value ? guest_email.value : "";

			const discount_type = document.querySelector("input[type=radio]:checked");
			const discount_amount = document.querySelector(
				".js-basket-builder-discount-amount"
			);
			const cart = document.querySelector(".js-basket-builder-cart");
			if (!discount_type || !cart) {
				button.textContent = "Missing fields!";
				setTimeout(() => {
					button.textContent = "Generate Basket Link";
				}, 2000);
				return;
			}

			button.textContent = "Generating...";

			fetch("/api/basket-builder", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					email,
					discount_type: discount_type.id,
					discount_amount: discount_amount ? discount_amount.value : false,
					cart: cart.value,
				}),
			})
				.then((response) => response.json())
				.then((data) => {
					button.textContent = "Link Generated!";
					const basketBuilderResult = document.querySelector(
						".js-basket-builder-result"
					);
					const basketBuilderResultWrapper = document.querySelector(
						".js-basket-builder-result-wrapper"
					);
					basketBuilderResult.setAttribute("data-key", data.url);
					basketBuilderResult.textContent = data.url;
					basketBuilderResultWrapper.style.display = "block";

					setTimeout(() => {
						guest_email.value = "";
						discount_amount.value = "";
						button.textContent = "Generate Basket Link";
					}, 2000);
				});
		});
	}
};
